import axiosHelper from "../../../../../../../axiosHelper";
import { APIUSEROLD, API_FAILURE, GET_ALL_VENDOR_NEED_APPROVAL, GET_ALL_VENDOR_NEED_PENDING, GET_SUPPLIER_NEED_APPROVAL } from "../../../../../../../config/constants";
import { apiErrors } from "../../../../../../../helper";

export function fetchAllVendoreNeedFormApprovalList(filter, callback) {
    return (dispatch) => {
      const request = axiosHelper.get(`${APIUSEROLD.getAllVendorNeedFormApprovalList}`, {
        params: {
          vendorRequirementRegistrationId:filter?.vendorRequirementRegistrationId,
          // page: filter.current_page,
          // pageSize: filter.per_page,
          // SearchType: filter?.sortField?.supplierName,
          // SortBy: filter?.sortField,
          // SortOrder: filter.sortOrder,
        }, // Assuming filter contains necessary query parameters
      });
      request
        .then((response) => {
          
          if (response?.data || response.status === 204) {
            dispatch({
              type: GET_ALL_VENDOR_NEED_APPROVAL,
              payload: {
                data: response.status === 204 ? [] : response?.data?.Result,
  
                filter, // Include filter in payload
              },
            });
            // callback(response, null);
          }
        })
        .catch((error) => {
          dispatch({ type: API_FAILURE });
          if (error.response.status === 401) {
            apiErrors(error)
          }else{

            callback(null, error);
          }
          // apiErrors(error);
        });
    };
  }
  export function fetchAllVendoreNeedFormPendingList(filter, callback) {
    return (dispatch) => {
      const request = axiosHelper.get(`${APIUSEROLD.getAllVendorNeedFormPendingList}`, {
        params: {
          vendorRequirementRegistrationId:filter?.vendorRequirementRegistrationId,
          // page: filter.current_page,
          // pageSize: filter.per_page,
          // SearchType: filter?.sortField?.supplierName,
          // SortBy: filter?.sortField,
          // SortOrder: filter.sortOrder,
        }, // Assuming filter contains necessary query parameters
      });
      request
        .then((response) => {
          
          if (response?.data || response.status === 204) {
            dispatch({
              type: GET_ALL_VENDOR_NEED_PENDING,
              payload: {
                data: response.status === 204 ? [] : response?.data?.Result,
  
                filter, // Include filter in payload
              },
            });
            // callback(response, null);
          }
        })
        .catch((error) => {
          dispatch({ type: API_FAILURE });
          if (error.response.status === 401) {
            apiErrors(error)
          }else{

            
            callback(null, error);
          }
          // apiErrors(error);
        });
    };
  }
  export function fetchSupplierNeedApprovalList(filter, callback) {
    
    return (dispatch) => {
      const request = axiosHelper.get(`${APIUSEROLD.getSupplierNeedApproval}`, {
        params: {
          vendorRequirementRegistrationId: filter?.vendorRequirementRegistrationId,
          employeeId:filter?.employeeId,
          workflowlevel:filter?.workflowlevel,
          EmployeeCode:filter?.EmployeeCode
        },
      });
  
      request
        .then((response) => {
          
          if (response?.data || response.status === 204) {
            dispatch({
              type: GET_SUPPLIER_NEED_APPROVAL,
              payload: {
                data: response.status === 204 ? [] : response?.data,
                filter, // Include Id in payload
              },
            });
            callback(response, null);
          }
        })
        .catch((error) => {
          dispatch({ type: API_FAILURE });
          if (error.response.status === 401) {
            apiErrors(error)
          }else{

            callback(null, error);
          }
        });
    };
  }